"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$style = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _dom = require("./dom");

var _events = require("./events");

var _variables = _interopRequireDefault(require("../variables"));

var _is_js = _interopRequireDefault(require("is_js"));

var _data = require("./data");

var _utilities = require("./_utilities");

var $style = function () {
  var localAPIs = {},
      emit = _events.$events.emit,
      add = _events.$events.add,
      addClass = _dom.$dom.addClass,
      removeClass = _dom.$dom.removeClass,
      callAll = _dom.$dom.callAll,
      get = _dom.$dom.get,
      each = _dom.$dom.each,
      slideAnimationDuration = 500,
      cssPropertyToCamelCase = function cssPropertyToCamelCase(string) {
    return string.replace(/-([a-z])/g, function (_all, letter) {
      return letter.toUpperCase();
    });
  },
      checkAndRunCallback = function checkAndRunCallback(fn) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (_is_js["default"]["function"](fn) && args.length > 0) {
      fn.apply(void 0, args);
    }
  };

  localAPIs.get = function (element) {
    var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var clean = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!Boolean(element)) return;
    if (_is_js["default"].string(element)) element = get(element);
    var styles = getComputedStyle(element);
    if (_is_js["default"].undefined(property)) return styles;
    return clean ? parseFloat(styles[property]) : styles[property];
  };

  localAPIs.set = function (target, property) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    callAll(target, function (el) {
      if (_is_js["default"].object(property)) {
        for (var _i = 0, _Object$entries = Object.entries(property); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              _value = _Object$entries$_i[1];

          el.style[key] = _value;
        }
      } else if (_is_js["default"].string(property) && _is_js["default"].string(value)) {
        el.style[cssPropertyToCamelCase(property)] = value;
      }
    });
    return (0, _utilities.optimizeTarget)(target);
  };

  localAPIs.remove = function (target, property) {
    property = (0, _utilities.filterStringArgs)(property);
    callAll(target, function (el) {
      _dom.$dom.each(property, function (prop) {
        prop = (0, _utilities.toDashesCase)(prop.trim());
        el.style.removeProperty(prop);
      });
    });
    return (0, _utilities.optimizeTarget)(target);
  };

  localAPIs.animate = function (element, animationName) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!Boolean(element) || !Boolean(animationName)) return;
    var defaults = {
      onComplete: null,
      animateInitClassName: 'animated',
      hideOnEnd: false
    };
    options = _data.$data.deepAssign(defaults, options);
    if (_is_js["default"].string(element)) element = get(element);
    element.removeAttribute('hidden');
    var classes = options.animateInitClassName + ' ' + animationName;
    addClass(element, classes);
    add('animationend', element, function () {
      removeClass(element, classes);
      if (options.hideOnEnd) _dom.$dom.attr(element, 'hidden', 'true');
      if (_is_js["default"]["function"](options.onComplete)) options.onComplete(element);
      emit(_variables["default"].customEventNames.animateEnd, window, {
        element: element
      });
    }, {
      once: true
    });
    return element;
  };

  localAPIs.animateChain = function (animationsArray) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (_is_js["default"].array(animationsArray) && animationsArray.length > 0) {
      var defaults = {
        onComplete: null,
        hideOnStart: true
      };
      options = _data.$data.deepAssign(defaults, options);
      var i = 0,
          l = animationsArray.length,
          animationElements = animationsArray.map(function (animation) {
        return animation.element;
      });

      if (options.hideOnStart) {
        each(animationElements, function (element) {
          localAPIs.set(element, {
            opacity: 0,
            visibility: 'hidden'
          });
        });
      }

      (function run(anim) {
        var element = anim.element,
            animationName = anim.animationName,
            callback = anim.callback,
            hideOnEnd = anim.hideOnEnd;
        if (options.hideOnStart) localAPIs.remove(element, 'opacity visibility');
        localAPIs.animate(element, animationName, {
          onComplete: function onComplete() {
            i++;
            if (_is_js["default"]["function"](callback)) callback.call(element, element);

            if (i < l) {
              run(animationsArray[i]);
            } else {
              if (_is_js["default"].not["null"](options.onComplete) && _is_js["default"]["function"](options.onComplete)) options.onComplete(animationElements);
            }
          },
          hideOnEnd: hideOnEnd
        });
      })(animationsArray[0]);
    }
  };

  localAPIs.slideUp = function (target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
      duration: slideAnimationDuration,
      onStart: null,
      onEnd: null
    };
    options = Object.assign(defaults, options);
    callAll(target, function (element) {
      checkAndRunCallback(options.onStart, element);
      localAPIs.set(element, {
        transitionProperty: 'height, margin, padding',
        transitionDuration: options.duration + 'ms',
        boxSizing: 'border-box',
        height: element.offsetHeight + 'px'
      });
      element.offsetHeight;
      localAPIs.set(element, {
        overflow: 'hidden',
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: 0,
        marginBottom: 0
      });

      _events.$events.add('transitionend', element, function () {
        localAPIs.set(element, 'display', 'none');
        localAPIs.remove(element, 'height, padding-top, padding-bottom, margin-top, margin-bottom, overflow, transition-duration, transition-property, box-sizing');
        checkAndRunCallback(options.onEnd, element);
      }, {
        once: true
      });
    });
  };

  localAPIs.slideDown = function (target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
      duration: slideAnimationDuration,
      onStart: null,
      onEnd: null
    };
    options = Object.assign(defaults, options);
    callAll(target, function (element) {
      checkAndRunCallback(options.onStart, element);
      localAPIs.remove(element, 'display');
      var display = window.getComputedStyle(element).display;
      if (display === 'none') display = 'block';
      localAPIs.set(element, 'display', display);
      var height = element.offsetHeight;
      localAPIs.set(element, {
        overflow: 'hidden',
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: 0,
        marginBottom: 0
      });
      element.offsetHeight;
      localAPIs.set(element, {
        boxSizing: 'border-box',
        transitionProperty: 'height, margin, padding',
        transitionDuration: options.duration + 'ms',
        height: height + 'px'
      });
      localAPIs.remove(element, 'padding-top, padding-bottom, margin-top, margin-bottom');

      _events.$events.add('transitionend', element, function () {
        localAPIs.remove(element, 'height, overflow, transition-duration, transition-property');
        checkAndRunCallback(options.onEnd, element);
      }, {
        once: true
      });
    });
  };

  localAPIs.slideToggle = function (target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
      duration: slideAnimationDuration,
      onDownStart: null,
      onDownEnd: null,
      onUpStart: null,
      onUpEnd: null
    };
    options = Object.assign(defaults, options);
    callAll(target, function (element) {
      if (localAPIs.get(element, 'display') === 'none') {
        localAPIs.slideDown(element, {
          duration: options.duration,
          onStart: options.onDownStart,
          onEnd: options.onDownEnd
        });
      } else {
        localAPIs.slideUp(element, {
          duration: options.duration,
          onStart: options.onUpStart,
          onEnd: options.onUpEnd
        });
      }
    });
  };

  localAPIs.offset = function (element) {
    var relativeTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'document';
    if (_is_js["default"].string(element)) element = get(element);

    switch (relativeTo) {
      case 'document':
        var rect = element.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {
          left: rect.left + scrollLeft,
          top: rect.top + scrollTop
        };

      case 'parent':
        return {
          left: element.offsetLeft,
          top: element.offsetTop
        };

      default:
        return null;
    }
  };

  return localAPIs;
}(window);

exports.$style = $style;